module.exports = __webpack_public_path__ + "static/media/motor.8c4e93d8.jpg";